import axios from "axios";
import React, { useEffect, useState } from "react";
import Footer from "./Footer";
const apiKey = "DGKyGeLtoN1tE1XEHJFZzQHzQHw3fROLdbkse58h0Ko";
// search Quary =https://api.unsplash.com/search/photos?page=1&query=office&client_id=
const LoadImg = () => {
    const [query, setquery] = useState("office")
    const [input, setinput] = useState("office");
    const [photos, setphotos] = useState([]);
    useEffect(() => {
        axios.get(`https://api.unsplash.com/search/photos?&query=${input}&client_id=${apiKey}`)
            .then((photos) => {
                setphotos(photos.data.results);
            })
    }, [input]);
    const Changephoto = () => {
        setinput(query)
    }
    return (
        <>
            <div className="searchbar"></div>
            <div className="searchhold">
                <div><input type="text" placeholder="search image.." onChange={(e) => { setquery(e.target.value) }} className="searchinput" /></div>
                <div><button type="submit" onClick={Changephoto} className="searchbtn"><i class="fa-solid fa-magnifying-glass"></i></button></div>
            </div>
            <br />
            {
                photos.length ? <p className="resultshow">Total result : {photos.length}</p> : <p className="resultshow">Total Results : {photos.length}</p>
            }
            <div className="imgcontaine">
                {
                    photos.map((img) => {
                        return (
                            <>
                                <a href={img.urls.small} data-lightbox="gl">
                                    <img src={img.urls.small} data-lightbox="gl" alt="" className="gridimg" />
                                </a>
                            </>
                        )
                    })
                }
            </div>
         { photos.length ? <Footer />: null}
        </>
    )
}

export default LoadImg;